module.exports = __webpack_public_path__ + "img/saglik-sigortasi.8200beae.png";